// CANONICAL COPY (GH #7115). src/constants/obligations/obl-disciplinary-process.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-disciplinary-process',
  title: 'Verify disciplinary process is documented',
  description:
    'Confirm that a formal disciplinary process for IS policy violations exists, is published, and has been communicated.',
  category: 'people',
  scfIds: ['SCF-PPL-004'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Disciplinary process policy is published' },
    { type: 'document-acknowledged', description: 'Policy has been acknowledged by personnel' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
